@import "tailwindcss";

:root {
  /* Dynamic kiosk theme — overridden at runtime by useTheme hook */
  --kiosk-accent: #d4872c;
  --kiosk-accent-hover: #e8a84c;
  --kiosk-bg: #0a0a0a;
  --kiosk-surface: #141414;
  --kiosk-surface-2: #1e1e1e;
  --kiosk-text: #f5f5f5;
  --kiosk-muted: #a0a0a0;
}

@theme inline {
  --color-kiosk-accent: var(--kiosk-accent);
  --color-kiosk-accent-hover: var(--kiosk-accent-hover);
  --color-kiosk-bg: var(--kiosk-bg);
  --color-kiosk-surface: var(--kiosk-surface);
  --color-kiosk-surface-2: var(--kiosk-surface-2);
  --color-kiosk-text: var(--kiosk-text);
  --color-kiosk-muted: var(--kiosk-muted);
}

/* Kiosk: fullscreen, no scrollbars, touch-optimized */
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: var(--kiosk-bg);
  color: var(--kiosk-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
  touch-action: manipulation;
}

/* Scrollable areas within the kiosk */
.kiosk-scroll {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.kiosk-scroll::-webkit-scrollbar {
  display: none;
}

/* Touch feedback */
.kiosk-btn {
  transition:
    transform 0.1s ease,
    opacity 0.1s ease;
}
.kiosk-btn:active {
  transform: scale(0.96);
  opacity: 0.9;
}

/* Pulse animation for attractor */
@keyframes kiosk-pulse {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
}
.kiosk-pulse {
  animation: kiosk-pulse 3s ease-in-out infinite;
}

/* Slide up animation */
@keyframes kiosk-slide-up {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.kiosk-slide-up {
  animation: kiosk-slide-up 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Fade in */
@keyframes kiosk-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.kiosk-fade-in {
  animation: kiosk-fade-in 0.3s ease;
}

/* Spin loader */
.kiosk-spinner {
  border: 4px solid var(--kiosk-surface-2);
  border-top-color: var(--kiosk-accent);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
